import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../../messages";
import BienvenidaServices from "./bienvenida.services";
import toastr from "toastr";

export const getBienvenida = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_BIENVENIDA,
      payload: true,
    });
    const resp = await BienvenidaServices.getBienvenida(filters);
    dispatch({
      type: actions.GET_BIENVENIDA,
      payload: {
        bienvenida: resp.data,
      },
    });
  } catch (ex) {
    let message = "";
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
  } finally {
    dispatch({
      type: actions.LOADING_BIENVENIDA,
      payload: false,
    });
  }
};

export const getBienvenidaPorUsuario = (data) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_BIENVENIDA_EMPLEADO,
      payload: true,
    });
    const resp = await BienvenidaServices.getBienvenidaPorUsuario(data);
    dispatch({
      type: actions.GET_BIENVENIDA_EMPLEADO,
      payload: {
        bienvenidaEmp: resp.data.data,
      },
    });
  } catch (ex) {
    let message = "";
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
  } finally {
    dispatch({
      type: actions.LOADING_BIENVENIDA_EMPLEADO,
      payload: false,
    });
  }
};

export const saveBienvenida = (data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_BIENVENIDA,
      payload: true,
    });
    const resp = await BienvenidaServices.saveBienvenida(data);
    dispatch({
      type: actions.GET_BIENVENIDA,
      payload: {
        bienvenida: resp.data,
      },
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_BIENVENIDA,
      payload: false,
    });
  }
};

export const editBienvenida = (id, data) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_BIENVENIDA,
      payload: true,
    });

    const resp = await BienvenidaServices.editBienvenida(id, data);

    dispatch({
      type: actions.GET_BIENVENIDA,
      payload: {
        bienvenida: resp.data,
      },
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_BIENVENIDA,
      payload: false,
    });
  }
};

export const deleteBienvenida = (id) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_BIENVENIDA,
      payload: true,
    });
    const resp = await BienvenidaServices.deleteBienvenida(id);
    dispatch({
      type: actions.GET_BIENVENIDA,
      payload: {
        bienvenida: {},
      },
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (Array.isArray(ex.response.data)) {
              ex.response.data.forEach((item) => {
                toastr.error(item);
              });
            } else {
              toastr.error(ex.response.data);
            }
            break;
          case 500:
            message = messages.errorMessage + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
  } finally {
    dispatch({
      type: actions.LOADING_BIENVENIDA,
      payload: false,
    });
  }
};
